import { ticketProps } from "@shared/components/tickets/constants";

export const dataQualityTicketType = "pm.data-quality.ticket";

export const clientId = "smx-process-mining";

export const dataQualityTicketProps = {
  ...ticketProps,
  field: "field",
  tableId: "tableId",
};

export const roles = {
  admin: "admin",
  user: "user",
  planner: "planner",
  ticketCreator: "ticket-creator",
};
